import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * The Figma text styles are custom utilities (globals.css). tailwind-merge has to know them
 * as size-like classes, or it reads `text-label-md` as a colour and drops it whenever a
 * `text-<colour>` sits in the same list.
 */
const textStyles = [
    'metric',
    'page-title',
    'section-title',
    'display-italic',
    'label-lg',
    'label-md',
    'label-sm',
    'sm-medium',
    'mono',
    'mono-sm',
];

const twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            'font-size': [{ text: textStyles }],
        },
    },
});

export function cn(...inputs: ClassValue[]) {
    return twMerge(clsx(inputs));
}
